// extracted by mini-css-extract-plugin
export var quantityInput = "_fi-0";